export default "__VITE_ASSET__c26c9b88__"